module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="l-device-status__tab ';
 if (obj.active) { 
__p+='is-active';
 } 
__p+='">'+
((__t=( obj.label ))==null?'':__t)+
'</div>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./js/modules/device-status/show/templates/tabTitle.html
// module id = 429
// module chunks = 0